import {
  AfterViewInit,
  Component,
  OnDestroy,
  OnInit,
  ViewChild,
  ViewContainerRef,
} from '@angular/core';
import { LangService } from '../../services/lang/lang.service';
import { SsoService } from '../../services/sso/sso.service';
import { ToastContainerDirective, ToastrService } from 'ngx-toastr';
import { environment } from 'src/environments/environment';
import { appVersionRelease } from 'src/environments/version';

@Component({
  selector: 'app-main',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.css'],
})
export class MainComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild(ToastContainerDirective, { static: true })
  toastContainer: ToastContainerDirective;
  @ViewChild('topContainer', { static: true, read: ViewContainerRef })
  topContainer: ViewContainerRef;
  public environment = environment;

  // Versión de la web
  public webVersion = appVersionRelease;

  // Para los mensajes de notificación
  private static instance: MainComponent;

  constructor(
    public ssoService: SsoService,
    public langService: LangService,
    private toastrService: ToastrService,
  ) {
    MainComponent.instance = this;
  }

  static getInstance(): MainComponent {
    return MainComponent.instance;
  }

  public destroyComponent() {
    if (this.topContainer) {
      this.topContainer.remove();
    }
  }

  async ngOnInit(): Promise<void> {
    setTimeout(async () => {
      const ticketSSO = await this.ssoService.getTicket();
      const languageId = ticketSSO?.Usuario?.Idioma?.Id;
      await this.langService.getText(languageId || 1, true);
    }, 1000);
  }

  async ngAfterViewInit() {
    // Asigno el contenedor para los mensajes de notificación
    this.toastrService.overlayContainer = this.toastContainer;
    await this.ssoService.getToken();
  }

  // Cuando se destruye el componente
  ngOnDestroy() {}

  // Estos métodos estáticos se usan para mostrar todas las notificaciones
  // de la aplicación desde módulos externos
  public static showSuccess(title: string, message: string, timeout: number) {
    MainComponent.getInstance().showSuccess(title, message, timeout);
  }

  public static showInfo(title: string, message: string, timeout: number) {
    MainComponent.getInstance().showInfo(title, message, timeout);
  }

  public static showWarning(title: string, message: string, timeout: number) {
    MainComponent.getInstance().showWarning(title, message, timeout);
  }

  public static showError(title: string, message: string, timeout: number) {
    MainComponent.getInstance().showError(title, message, timeout);
  }

  public showSuccess(title: string, message: string, timeout: number) {
    this.toastrService.success(message, title, {
      timeOut: timeout,
      positionClass: 'toast-top-center',
      enableHtml: true,
    });
  }

  public showInfo(title: string, message: string, timeout: number) {
    this.toastrService.info(message, title, {
      timeOut: timeout,
      positionClass: 'toast-top-center',
      enableHtml: true,
    });
  }

  public showWarning(title: string, message: string, timeout: number) {
    this.toastrService.warning(message, title, {
      timeOut: timeout,
      positionClass: 'toast-top-center',
      enableHtml: true,
    });
  }

  public showError(title: string, message: string, timeout: number) {
    this.toastrService.error(message, title, {
      timeOut: timeout,
      positionClass: 'toast-top-center',
      enableHtml: true,
    });
  }
}
